import { render, staticRenderFns } from "./HorizontalNavMenuGroup.vue?vue&type=template&id=4b6bebed"
import script from "./HorizontalNavMenuGroup.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./HorizontalNavMenuGroup.vue?vue&type=style&index=0&id=4b6bebed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports